import { render } from "./QcWorkscreen.vue?vue&type=template&id=5b5d40af&scoped=true"
import script from "./QcWorkscreen.vue?vue&type=script&lang=js"
export * from "./QcWorkscreen.vue?vue&type=script&lang=js"

import "./QcWorkscreen.vue?vue&type=style&index=0&id=5b5d40af&scoped=true&lang=css"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5d40af"]])

export default __exports__